import {
  TRACKING_LOADING,
  TRACKING_ERROR,
  TRACKING_FINISHED,
} from '../types/TrackingTypes';

const initialState = {
  loading: false,
  error: false,
  finishedLoading: false,
};

const trackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRACKING_LOADING:
      return { ...state, loading: true };
    case TRACKING_ERROR:
      return { ...state, loading: false, error: true };
    case TRACKING_FINISHED:
      return { ...state, loading: false, error: false, finishedLoading: true };
    default:
      return state;
  }
};

export default trackingReducer;
